/**
 * Filter types enum
 */
export enum FILTER_PANEL_TYPES {
  SINGLE_VALUE = 'single_value',
}
